const formatMoney = (n) => n && !Number.isNaN(n) && `$${n.toFixed(2)}`

export default {
  formatMoney,
}